import React, { Component } from 'react';
import { Provider } from 'mobx-react';
import LiveClassModel from './model';

class LiveClassProvider extends Component {
  constructor(props) {
    super(props);
    this.model = new LiveClassModel(this);
    this.model.actions.syncProps(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.model.actions.syncProps(nextProps);
  }

  render() {
    return <Provider liveClassModel={this.model}>{this.props.children}</Provider>;
  }
}

export { LiveClassProvider };
